import { Injectable } from '@angular/core';
import { UserCredentials } from '../../model/user-credentials';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import { isUndefined } from 'util';
import { Api } from '../../core/api';

@Injectable()
export class UserService {
  private isLogged$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private editEnabled$: BehaviorSubject<boolean> = new BehaviorSubject(this.api.fetchToken('modificationsEnabled'));

  constructor(private api: Api) {}

  public get editEnabled(): Observable<boolean> {
    return this.editEnabled$;
  }

  public isLogged(): Observable<boolean> {
    return this.isLogged$.asObservable();
  }

  logout() {
    this.api.clearToken();
    this.isLogged$.next(false);
    this.editEnabled$.next(false);
  }

  public login(credentials: UserCredentials): Observable<boolean> {
    const secrets = {
      client_id: 'testclient',
      client_secret: 'testpass'
    };

    const payload = { ...secrets, ...credentials };
    return this.api
      .getToken('password', payload)
      .catch(error => {
        this.isLogged$.next(false);
        return Observable.throw(error);
      })
      .do(user_status => {
        this.editEnabled$.next(user_status.modificationsEnabled);
        this.isLogged$.next(!isUndefined(user_status));
      });
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/resources/user/user.service.ts